/* eslint-disable no-restricted-globals */
/* eslint-disable react-hooks/exhaustive-deps */
import {
	Button,
	AlertDialog,
	AlertDialogBody,
	AlertDialogContent,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogOverlay,
	Tooltip,
	IconButton,
	useDisclosure,
	useToast,
} from '@chakra-ui/react';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { gql, useMutation } from '@apollo/client';
import c from '../../../constant';

const M_DELETE = gql`
	mutation deleteNpRelation($relationId: String!) {
		deleteNpRelation(relationId: $relationId) {
			id
			createdBy
			createdAt
			step
			number
			subject
			references
			description
			attachments
			attachings
			proposalNumber
			doneFile
			allowAddingOtherAttachments
			type
			office
			department
			completedAt
			urgent
			createdByUser {
				id
				username
				fullName
				fullNameKhmer
				avatar
				position
				office
				department
			}
			viewers {
				id
				createdAt
				createdBy
				userViewer {
					id
					username
					fullName
					fullNameKhmer
					avatar
					department
					office
				}
			}
			timelines {
				id
				createdAt
				user {
					id
					username
					fullName
					fullNameKhmer
				}
				action
				description
			}
			proposal {
				id
				no
			}
			checkInAt
			checkOutAt
			checkInDdgAt
			checkInDgAt
			assistantColor
			isDepartmentLevel
			relation {
				id
				np {
					id
					number
					subject
					step
				}
				offices
				departments
				relations {
					id
					number
					subject
					step
				}
				createdAt
				updatedAt
				deleted
			}
			taggings {
				id
				npId
				tag {
					id
					createdAt
					createdBy
					name
				}
			}
		}
	}
`;

function RelationDeletion({ relationId = null, onComplete = (np) => null }) {
	const toast = useToast();
	const modalDelete = useDisclosure();
	const { t } = useTranslation();
	const [deleteNpRelation, { loading: loadingDelete }] = useMutation(M_DELETE);

	return (
		<>
			<Tooltip label={t('DELETE COMMENT')}>
				<IconButton
					onMouseDown={modalDelete?.onOpen}
					isLoading={loadingDelete}
					icon={<FontAwesomeIcon icon={faTrash} style={{ fontSize: 10 }} />}
					colorScheme="red"
					variant="solid"
					size="xs"
					borderRadius={c.borderRadius}
				/>
			</Tooltip>
			<AlertDialog closeOnEsc={!loadingDelete} closeOnOverlayClick={!loadingDelete} isOpen={modalDelete?.isOpen} onClose={modalDelete?.onClose}>
				<AlertDialogOverlay>
					<AlertDialogContent>
						<AlertDialogHeader fontSize="lg" fontWeight="bold">
							{t('Delete')}
						</AlertDialogHeader>
						<AlertDialogBody>{t("Are you sure? You can't undo this action afterwards")}</AlertDialogBody>
						<AlertDialogFooter>
							<Button isDisabled={loadingDelete} onMouseDown={modalDelete?.onClose}>
								{t('Cancel')}
							</Button>
							<Button
								ml={4}
								isLoading={loadingDelete}
								colorScheme="red"
								onClick={() => {
									deleteNpRelation({ variables: { relationId } })
										.then(({ data }) => {
											modalDelete?.onClose();
											onComplete(data?.deleteNpRelation);
										})
										.catch((error) => {
											modalDelete?.onClose();
											toast({
												title: t(error?.message ? error?.message : 'something went wrong'),
												status: 'error',
												isClosable: true,
												position: 'bottom-right',
											});
										});
								}}
							>
								{t('Delete')}
							</Button>
						</AlertDialogFooter>
					</AlertDialogContent>
				</AlertDialogOverlay>
			</AlertDialog>
		</>
	);
}

export default RelationDeletion;
